const jQuery = require("jquery");
const $ = jQuery;
const moment = require('moment');

const basic_js = (function () {
    $(window).on('load', function () { });
    $(window).on('scroll', function () { });
    $(document).ready(function () {
        app_init.ready();
    });
    const app_init = {
        ready: function ready() {
            my_app.init();
            my_app.form.init();
            my_app.countdown.init();
            my_app.phoneValidation.init();
        }
    };
    const my_app = {
        init: function init() {
            console.log('APP INIT')

            // $('.banner-form').each(function(){  
            //     var highestBox = 0; 
            //     $(this).find('.field-group').each(function(){
            //         if($(this).height() > highestBox){  
            //             highestBox = $(this).height();  
            //         }
            //     }) 
            //     $(this).find('.field-group').height(highestBox);
            // }); 

            // __ __ Validation __ __ //
            // __ __ __ __ __ __ __ _ //
            
            $('input').on('blur', function(e){
                if(e.target.id == 'email'){


                        
                    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    let data_valid_email = regex.test(e.target.value);
                    console.log(data_valid_email);
                    if(data_valid_email){
                        $(e.target).removeClass("is-invalid");
                        $(e.target).addClass("is-valid");
                    }
                    else{
                        $(e.target).removeClass("is-valid");
                        $(e.target).addClass("is-invalid");
                    }
                }
                else if(e.target.id =='telephone'){
                    
                }
                else
                {
                    if(e.target.value){
                        $(e.target).removeClass("is-invalid");
                        $(e.target).addClass("is-valid");
                    }
                    else {
                        $(e.target).removeClass("is-valid");
                        $(e.target).addClass("is-invalid");
                    }
                }



            });


            $('select').on('change',function(e){
                $(e.target).addClass("is-valid");
            });

            // __ __ __ __ __ __ __ _ //

            $(".cta.jump-to-form").on("click", function (e) {
                $('html, body').animate({
                    scrollTop: 0
                }, 2000);
            })

            $(".accordian-item").on("click", function (e) {
                e.preventDefault();
                console.log("")
                let p = $(this).find("p:last-of-type");
                let h_val = {};

                if (p.height() > 0) {
                    h_val = {
                        "height": "0px",
                        "padding-top": "0px"
                    }
                } else {
                    h_val = {
                        "height": "auto",
                        "padding-top": "15px"
                    }
                }

                p.css(h_val)

            })
            function postCode_(e) {
                e = e.replace(/\s/g, "");
                return /^(([A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2})|([A-Z]{1,2}[0-9][A-Z] ?[0-9][A-Z]{2,3}))$/i.test(e)
            }
            function getlength(number) {
                return number.toString().length;
            }
            $(document).on('keyup',"#postcode",function(){
                var str = $(this).val();
                 str = str.replace(/\s/g, '');
                 if (getlength(str) >= 5 && postCode_(str) ) {
                     $("#postcode").removeClass("is-invalid").addClass("is-valid");
                     //$("#address").removeClass("is-invalid").addClass("is-valid");
                     $(".postcodeLookup").click();
                 }else{
                    $('#AddressCapture_FindButton').removeClass('active_now');
                     console.log('in the check of error');
                     $("#postcode").addClass("is-invalid").removeClass("is-valid");
                     $("#address").addClass("is-invalid").removeClass("is-valid");
                     $("#address").val("");
                     $('#company').val('');
                      $('#address_line1').val('');
                      $('#address_line2').val('');
                      $('#address_line3').val('');
                      $('#city').val('');
                      $('#province').val('');
                      $('#address').attr('type','hidden');
                 }
             });
             
            $(document).on('click','.postcodeLookup',function(){
                var current_button = $(this); 
                   setTimeout(function(){  
                      var myVar = setInterval(function(){
                          console.log('insideddddddyee');
                            if($('#line1').val() != ''  ){
                               var address1 = $('#line1').val();
                               var address2 = $('#line2').val();
                               var address3 = $('#line3').val();
                               var city = $('#city').val();
                               var county = $('#province').val();
                               var company = $('#company').val();
                               var postcode = $('#postcode').val();
             
                               var main_address = '';
                               if (company != '') {
                                     main_address = company;
                               }
                               if (address1 != '') {
                                     if (main_address == '') {
                                        main_address = address1;
                                     } else {
                                        main_address += ', ' + address1;
                                     }
                               }
                               if (address2 != '') {
                                     if (main_address == '') {
                                        main_address = address2;
                                     } else {
                                        main_address += ', ' + address2;
                                     }
                               }
                               if (address3 != '') {
                                     if (main_address == '') {
                                        main_address = address3;
                                     } else {
                                        main_address += ', ' + address3;
                                     }
                               }
                               if (city != '') {
                                     if (main_address == '') {
                                        main_address = city;
                                     } else {
                                        main_address += ', ' + city;
                                     }
                               }
                               if (county != '') {
                                     if (main_address == '') {
                                        main_address = county;
                                     } else {
                                        main_address += ', ' + county;
                                     }
                               }
                               if (postcode != '') {
                                     if (main_address == '') {
                                        main_address = postcode;
                                     } else {
                                        main_address + ', ' + postcode;
                                     }
                               }
                               clearInterval(myVar);
                               if(main_address != "" && main_address != postcode){  
                                     $('#address').attr('type','text');
                                     $('#address').val(main_address);
                                     $('#address-err').text("");
                                     $('#email-err').text("");
                                     $("#postcode").removeClass("is-invalid").addClass("is-valid");
                                     $('#address').removeClass("is-invalid").addClass("is-valid");
                                     $('#AddressCapture_FindButton').removeClass('active_now');
                                    //  $('.postcode_error').hide();
                                     return main_address;
                                     
                               }
                               
                        }
                        }, 1000);
                  }, 1300); 
             
              });
        },
        form: {
            form_info: {},
            test_form_info: {
                "owner": "James",
                "gas_boiler": "yes",
                // "property_type": "house",
                // "built_before_1990": "no",
                // "EPC": "yes",
                // "min_four_beds": "yes",
                // "cavity_wall_insulation": "yes",
                // "building_material": "brick",
                // "loft_insulation": "yes",
                // "conservation_area": "no",
                // "energy_bill": "£50",
                "title": "Mr",
                "firstname": "James",
                "lastname": "exton",
                "email": "james@genius.co.uk",
                "house_no": "5",
                "line1": "5, Benbow Close",
                "line2": "test",
                "line3": "london",
                "postcode": "AL1 5SA",
                "telephone": "07123456789"
            },
            field_groups: "",
            progress_percent: "",
            init: function init() {
                $('form.banner-form').on('keyup keypress', function (e) {
                    var keyCode = e.keyCode || e.which;
                    if (keyCode === 13) {
                        e.preventDefault();
                        return false;
                    }
                });


                if (!window.location.href.includes("thankyou")) {

                    $.loadScript = function (url, callback) {
                        $.ajax({
                            url: url,
                            dataType: 'script',
                            success: callback,
                            async: true
                        });
                    }

                    $.loadScript('https://webservices.data-8.co.uk/javascript/loader.ashx?key=HXIK-AIN2-7UXG-GM56&load=InternationalTelephoneValidation,EmailValidation', function () { });
                    $.loadScript('https://webservices.data-8.co.uk/javascript/address_min.js', function () {

                        console.log("TEST....")
                        new data8.postcodeLookupButton(
                            [{
                                element: 'line1',
                                field: 'line1'
                            },
                            {
                                element: 'line2',
                                field: 'line2'
                            },
                            {
                                element: 'line3',
                                field: 'line3'
                            },
                            {
                                element: 'postcode',
                                field: 'postcode'
                            }
                            ,
                            {
                                element: 'city',
                                field: 'town'
                            },
                            {
                                element: 'province',
                                field: 'county'
                            }

                            ], {
                            ajaxKey: 'HXIK-AIN2-7UXG-GM56',
                            license: 'WebClickFull'
                        }
                        ).show();





                        
                        // $('#line1').attr('type','text');

                        $("#lookup").on("click", function (e) {
                            e.preventDefault();
                            console.log("TEST....")

                        })

                    });

                }



                // // <script type="text/javascript" src="https://webservices.data-8.co.uk/javascript/jqueryvalidation_min.js"></script>
                // $.loadScript('https://webservices.data-8.co.uk/javascript/jqueryvalidation_min.js', function(){ });
                // initializeInlineData8Validation();

                this.field_groups = $(".field-group").length
                this.progress_percent = 100 / parseFloat($(".field-group").length)
                $(".form-progress").css("width", this.progress_percent + "%")
                this.form_action();
                // this.test_form_action(); // TEST FUNCTION
            },
            postcode_validate: function postcode_validate(pc) {

                let is_valid = true;
                [

                    "DT7", "EX1", "EX10", "EX11", "EX12", "EX13", "EX14",
                    "EX15", "EX16", "EX17", "EX18", "EX19", "EX2", "EX20",
                    "EX21", "EX22", "EX23", "EX3", "EX31", "EX32", "EX33",
                    "EX34", "EX35", "EX36", "EX37", "EX38", "EX39", "EX4",
                    "EX5", "EX6", "EX7", "EX8", "EX9", "PL1", "PL15", "PL16",
                    "PL19", "PL20", "PL21", "PL3", "PL4", "PL5", "PL6", "PL7",
                    "PL8", "PL9", "TA21", "TQ1", "TQ10", "TQ11", "TQ12",
                    "TQ13", "TQ14", "TQ2", "TQ3", "TQ4", "TQ5", "TQ6", "TQ7",
                    "TQ8", "TQ9", // POSTCODES IN DEVON

                    "EX22", "EX23", "PL10", "PL11", "PL12", "PL13", "PL14", "PL15",
                    "PL17", "PL18", "PL22", "PL23", "PL24", "PL25", "PL26", "PL27",
                    "PL28", "PL29", "PL30", "PL31", "PL32", "PL33", "PL34", "PL35",
                    "TR1", "TR10", "TR11", "TR12", "TR13", "TR14", "TR15", "TR16",
                    "TR17", "TR18", "TR19", "TR2", "TR20", "TR26", "TR27", "TR3",
                    "TR4", "TR5", "TR6", "TR7", "TR8", "TR9", // POSTCODES IN CORNWALL

                    "HS", " IV", " KA27", " KA28", " KW", " PA20-49", " PA60-78", " ZE" // SCOTTISH ISLES

                ].forEach(element => {
                    // console.log("elem: " + JSON.stringify(element, null, 2));
                    if (pc.length >= element.length) {
                        var res = pc.substring(0, element.length);
                        if (res.toLowerCase() == element.toLowerCase()) {
                            console.log("comparing exact postcode: " + res.toLowerCase() + " -  " + element.toLowerCase());
                            is_valid = false;
                        }
                    }
                });

                return is_valid;


            },
            form_validate: function form_validate(value) {
                let _this = this;
                debugger;
                if (value.btn_val == "address") {
                    return _this.postcode_validate($("#postcode").val())
                }
                if (value.btn == "gas_boiler" && value.btn_val == "no") {
                    return false
                }
                if (value.btn == "owner" && value.btn_val == "no") {
                    return false
                }
                if (value.btn == "min_four_beds" && value.btn_val == "no" && _this.form_info.built_before_1990 == "yes") {
                    return false
                }
                if (value.btn == "loft_insulation" && value.btn_val == "no") {
                    return false
                }
                if (value.btn == "EPC" && value.btn_val == "no" && _this.form_info.built_before_1990 == "no") {
                    return false
                }
                if ((value.btn == "select" && value.btn_val == "building_material" && $("#" + value.btn_val + " option:selected").val() != "brick")) {
                    return false
                }
                if (value.btn == "conservation_area" && value.btn_val == "yes") {
                    return false
                }
                return true
            },
            getlength: function getlength(number) {
                return number.toString().length;
            },
            isnotInteger: function isnotInteger(data) {
                if ($.isNumeric(data)) {
                    return false;
                } else {
                    return true;
                }
            },
            validatephone: function validatephone(no) {
                debugger
                let _this = this;
                var is_telephone_varified = 0;
                var inside = false;
                var number = no;
                var number_length = _this.getlength(number);
                if ((number_length < 10 || number_length > 13) || (number_length == 10 && number.substring(0, 1) == '0')) {
                    debugger
                    return is_telephone_varified = 0;
                } else if (_this.isnotInteger(number)) {
                    return is_telephone_varified = 0;
                } else {
                    debugger
                    var uk_mob_number = number;
                    if (number_length < 11 && uk_mob_number.substring(0, 1) != '0') {
                        uk_mob_number = '0' + uk_mob_number;
                    } else if (number_length > 11 && uk_mob_number.substring(0, 2) == '44') {
                        uk_mob_number = uk_mob_number.replace(/^44/, '0');
                    } else if (number_length > 12 && uk_mob_number.substring(0, 3) == '+44') {
                        uk_mob_number = uk_mob_number.replace('+44', '0');
                    } else if (number_length > 12 && uk_mob_number.substring(0, 4) == '0044') {
                        uk_mob_number = uk_mob_number.replace(/^0044/, '0');
                    }
                    number = uk_mob_number;
                    debugger
                    if (_this.getlength(number) == 11) {
                        inside = true;
                        debugger
                        $.ajax({
                            url: "/mobile-validation.php",
                            data: { number: number },
                            type: "post",
                            success: function (data) {
                                console.log("data", data);
                                if (data == 1) {
                                    return is_telephone_varified = 1;
                                } else {
                                    return is_telephone_varified = 0;
                                }
                            }
                        });
                    } else {
                        debugger
                        return is_telephone_varified = 0;
                    }
                }
            },
            isEmail: function isEmail(email) {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            },
            // post_waypoint: function post_waypoint(payload){ 
            //     console.log('HEATPUMP DATA: ' + JSON.stringify( payload, null, 2));

            //     $.post("https://bizmiuk.waypointsoftware.com/capture.php?xAuthentication=87ab926a4624c0878a40991976fe8acb",payload,  function(data, status){
            //         if(data){
            //             console.log("DATA" + data);
            //         }
            //     }); 
            //     // window.location.href = "/thankyou.html";  
            // },
            form_action: function form_action() {
                console.log("form_action");
                let _this = this;

                $(".search_btn").on("click", function (e) {
                    e.preventDefault();
                    console.log("search EPC");

                    let payload = {
                        method: 'search_postcode',
                        data: $("#postcode")
                    }
                    my_app.db_req.send(payload, true).then((response) => {
                        // console.log('my response: ' + JSON.stringify(response, null, 2));
                        if (response.success) {
                            let addresses = response.address_data
                            let options_string = "";
                            addresses.array.forEach(element => {
                                let opt = "<option value='" + element.lmk - key + "'>" + element.address + "</option>";
                                options_string += opt;
                            });
                            $("#address_list").html(options_string);
                        } else {
                            // not supplied postcode or house number 
                            // not in our critera group
                            window.location.href = "/thankyou.html";

                            response.error
                        }
                    });



                });
                
                // $('#note_modal').on("click", function (e){
                //     $("#note_modal").removeClass("modal_wrap")
                //     $("#note_modal").addClass("modal_hide")

                // })


                $(".want_answer_yes").on("click", function (e) {
                    var count = 0;
                    console.log("hello"); 
                    console.log(_this.test_form_info);
                    if(e.target.name == 'cavity_wall_insulation' && e.target.value == 'yes'){
                        $('#is_solid_brick').hide();
                        $('#no_of_bedrooms').fadeIn("slow");  
             
                    }
                    else if(e.target.name == 'cavity_wall_insulation' && e.target.value == 'no')
                    {

                        $('#is_solid_brick').fadeIn("slow");
                    }

                    $("#note_modal input[type=radio]").each(function() {

                        if(this.checked == true)
                        {
                            count ++;
                        }
                        
                        if($('#bedrooms').is(":visible")){
                            if(count >= 4){
                                $('#btn-to-qualify').prop('disabled', false);
                            }
                        }
                        else{
                            if(count >= 5){
                                $('#btn-to-qualify').prop('disabled', false);
                            }
                        }
 
                    });
                });


                $(".btn_back").on("click", function (e) {
                    $(".hidden-error").removeClass("display-errors");
                });

                

                //__ __ new __ __ //
                $("#btn-to-qualify").on("click", function (e) {
                    e.preventDefault();
                    console.log("search EPC");
                    $(".site_loader").show()
                    $("#note_modal").addClass("modal_hide");
                    $("#note_modal").removeClass("modal_wrap");
                    
                    let do_you_use_a_minimum_of_15000klws = $("input[name='15000klws']:checked").val();
                    let do_you_have_loft_insulation = $("input[name='loft_insulation']:checked").val();
                    let do_you_have_cavity_wall= $("input[name='cavity_wall_insulation']:checked").val();
                    let is_your_property_solid_brick = $("input[name='property_solid_brick']:checked").val();
                    let how_many_bedrooms_does_your_property_have = $("#bedrooms").val();
                    let was_your_property_built_before_1990 = $("input[name='property_built_before']:checked").val();

                    var formdata = _this.form_info;
                    var querystring = serialize(formdata);
                    console.log(querystring);
                    formdata.do_you_use_a_minimum_of_15000klws = do_you_use_a_minimum_of_15000klws; 
                    formdata.do_you_have_loft_insulation = do_you_have_loft_insulation; 
                    formdata.do_you_have_cavity_wall = do_you_have_cavity_wall; 
                    formdata.is_your_property_solid_brick = is_your_property_solid_brick; 
                    formdata.how_many_bedrooms_does_your_property_have = how_many_bedrooms_does_your_property_have; 
                    formdata.was_your_property_built_before_1990 = was_your_property_built_before_1990; 
                    formdata.force_submit = true
                    let payload = {
                        method: 'EPC_SEARCH',
                        data: formdata
                    }
                    my_app.db_req.send(payload, false).then((response) => {
                        console.log('my response: ' + JSON.stringify(response, null, 2));

                        if (response.success) {
                            // _this.test_form_info.epc_verified = response.epc_response
                            // _this.test_form_info.exact_match = response.exact_match
                            // my_app.form.post_waypoint();
                            console.log("response.in_EPC");
                            console.log(response);
                            if(response.in_EPC  == false && response.waypoint_response != "ACCEPTED"){
                                $("#note_modal").addClass("modal_wrap");
                                $("#note_modal").removeClass("modal_hide");
                                
                            }
                            else if(response.in_EPC  == false && response.waypoint_response == "ACCEPTED"){
                                if(response.source == 'silver'){
                                    window.location.href = "/thank_you.html?epc=" + response.EPC_qualify+'&'+querystring;
                                }
                                else if(response.source == 'silver_not_qualify'){
                                    $(".site_loader").hide()
                                    $("#not_qualify_modal2").addClass("modal_wrap");
                                    $("#not_qualify_modal2").removeClass("modal_hide");
                                    // fbq('track', 'LeadNotQualify');  
                                    fbq_custom("LeadNotQualify", window.location.href, formdata);                            
                                }
                                else
                                {
                                    $(".site_loader").hide()
                                    $("#not_qualify_modal").addClass("modal_wrap");
                                    $("#not_qualify_modal").removeClass("modal_hide");
                                    // fbq('track', 'LeadNotQualify');
                                    fbq_custom("LeadNotQualify", window.location.href, formdata);
                                }
                            }
                            else if(response.source == 'silver_not_qualify'){
                                $(".site_loader").hide()
                                $("#not_qualify_modal2").addClass("modal_wrap");
                                $("#not_qualify_modal2").removeClass("modal_hide");
                                // fbq('track', 'LeadNotQualify'); 
                                fbq_custom("LeadNotQualify", window.location.href, formdata);                               
                            }
                            else if(response.EPC_qualify == 'NO'){
                                $(".site_loader").hide()
                                $("#not_qualify_modal").addClass("modal_wrap");
                                $("#not_qualify_modal").removeClass("modal_hide");
                                // fbq('track', 'LeadNotQualify');
                                fbq_custom("LeadNotQualify", window.location.href, formdata);
                            }else{
                                console.log(response.source);
                                if(response.source == 'silver'){
                                    window.location.href = "/thank_you.html?epc=" + response.EPC_qualify+'&'+querystring;;
                                }
                                else
                                {
                                    window.location.href = "/thankyou.html?epc=" + response.EPC_qualify+'&'+querystring;;
                                }
                                
                            }

                        } else {
                            // not supplied postcode or house number 
                            // not in our critera group
                            console.log(response.error)
                            if (response.error != "") {
                                $(".custom-error").html("Unfortunately your postcode isn't eligible for this campaign.")
                            }
                            $(".custom-error").html(response.EPC_fail_reason)
                            $(".hidden-error").addClass("display-errors")

                        }
                    });

                });

                // __ __ Next button working __ __ //
                $(".field-group .cta").on("click", function (e) {
                    console.log("SUBMIT")
                    e.preventDefault();
                    $('.form-title').text('Continue to see if you qualify');
                    $('body').addClass("hide_bottom_content");
                    let obj = JSON.parse($(this).attr("data-btn"))
                    let current_field_group = $(this).parents(".field-group")
                    let new_group = null
                    let empty_val = false;

                    if(new_group == 3){
                        $('.form-title').html('<span>Almost there</span> <span class="just_few">Just a few more details</span> ');
                    }
                    else if(new_group == 4){
                        $('.form-title').html('One moment');
                        
                    }
                    console.log("obj.btn", obj.btn);
                    if (obj.btn == "text" || obj.btn == "email" || obj.btn == "tel") {
                        current_field_group.find("input[type=" + obj.btn + "]").each(function () {
                            let input_item = $(this);
                            var element_name = $(this).attr("name");
                            if(element_name == "line3"){
                                
                            }
                            else if(element_name == "house_no"){
                                
                            }
                            else if (input_item.val().length < 1) {
                                current_field_group.find("label").addClass("error-missing");
                                empty_val = true;
                            }

                        });
                    }
                     
                    var firstname = "";
                    var lastname  = "";
                    if (obj.btn_val == "names") {
                        firstname = $('#firstname').val();
                        lastname  = $('#lastname').val();
                        if(firstname == ""){
                            $("#firstname-err").text("First Name is requried!");

                            $("#lastname-err").text("");
                            return
                        }else if (lastname == "") {
                            $("#lastname-err").text("Last Name is required!");

                            $("#firstname-err").text("");
                            return
                        }
                    }




                    var address
                    // if (obj.btn_val == "address") {
                    //     alert(btn_val);

                    //     email = $('#email').val();
                    //     address  = $('#address').val();

                    //     if(email == ""){
                    //         $("#email-err").addClass("error-missing-phone");
                    //         current_field_group.find("label").removeClass("error-missing");
                    //         $("#email-err").text("Email is requried!");
                    //         $("#address-err").text("");
                    //         return
                    //     }else if (address == "") {
                    //         $("#address-err").addClass("error-missing-phone");
                    //         current_field_group.find("label").removeClass("error-missing");
                    //         $("#address-err").text("Address is required!");
                    //         $("#email-err").text("");
                    //         return
                    //     }
                    // }
    

                    debugger
                    var number
                    var data_valid = "1";
                    
                    if (obj.btn_val == "telephone") {   
                        data_valid  = $('#tel-check').val();
                        if (data_valid == "0" || data_valid == "") {
                            if (number == "") {
                                
                                $('#phone-err').text("Phone number is required!");
                            } else {
                                $('#phone-err').text("Please enter a valid phone number");
                            }
                            return
                        }
                        $('#phone-err').text("");

                        var email = $("#email").val();
                        var address  = $('#address').val();
                        var data_valid_email = true;
                        if($("#email").val() == ""){
                            $("#email-err").text("Email is requried!");
                            return;
                        }
                        else {
                            data_valid_email = _this.isEmail(email);
                            console.log("data_valid_email", data_valid_email);
                            if(data_valid_email == false){

                                $("#email-err").text("Please enter a valid email address!");
                                return;
                            }
                            else{
                                $("#email-err").text("");
                            }
                        }
                        if (obj.btn_val == "email") {
                            current_field_group.find("input[type=" + obj.btn + "]").each(function () {
                                let input_item = $(this);
                                email = input_item.val();
                                
                            });
                        }

                        console.log("address", address);

                        if(address == ""){
                            $("#address-err").text("Address is required!");
                            return;
                        }
                        else {
                            $("#address-err").text("");
                        }

                    }


                    
                 
                    if (!empty_val ) {
                        if (_this.form_validate(obj)) {
                            if (obj.btn == "select") {
                                _this.form_info[obj.btn_val] = $("#" + obj.btn_val + " option:selected").val()
                            } else if (obj.btn == "text" || obj.btn == "email" || obj.btn == "tel") {
                                current_field_group.find("input[type=" + obj.btn + "]").each(function () {
                                    let input_item = $(this);
                                    _this.form_info[input_item.attr("id")] = input_item.val();
                                });
                            } else {
                                _this.form_info[obj.btn] = obj.btn_val;
                                if (obj.btn == "cavity_insulation" && obj.btn_val == "yes") {
                                    new_group = parseInt(current_field_group.attr("data-group")) + 2
                                }
                            }

                            _this.form_info.line1 = $("#line1").val();
                            _this.form_info.line2 = $("#line2").val();
                            _this.form_info.line3 = $("#line3").val();
                            _this.form_info.email = $("#email").val();
                            _this.form_info.house_no = $("#house_no").val();

                            new_group = new_group != null ? new_group : parseInt(current_field_group.attr("data-group")) + 1
                            // if(new_group == 4){
                            //     new_group = new_group + 1;
                            // }
                            if(new_group == 3){
                                // fbq('track', 'InitiateLeadForm');
                                fbq_custom("InitiateLeadForm", window.location.href, _this.form_info);
                                $('.form-title').html('<span>Almost there</span> <span class="just_few">Just a few more details</span> ');
                            }
                            else if(new_group == 4){
                                $('.form-title').html('One moment');
                                
                            }
                            $(".field-group[data-group=" + new_group + "]").addClass("temp-active")
                            current_field_group.removeClass("active-group")
                            $(".temp-active").addClass("active-group")

                            console.log("width: " + (new_group * _this.progress_percent))
                            console.log("new_group", new_group);
                            console.log('FORM INFO: ' + JSON.stringify(_this.form_info, null, 2));
                            if (new_group == 4) {
                                let payload = {
                                    method: 'EPC_SEARCH',
                                    data: _this.form_info
                                }

                                var formdata = _this.form_info;
                                var querystring = serialize(formdata);
                                console.log(querystring);
                                my_app.db_req.send(payload, false).then((response) => {
                                    console.log('my response: ' + JSON.stringify(response, null, 2));

                                    if (response.success) {
                                        // _this.test_form_info.epc_verified = response.epc_response
                                        // _this.test_form_info.exact_match = response.exact_match
                                        // my_app.form.post_waypoint();
                                        console.log("response.in_EPC");
                                        console.log(response);
                                        if(response.in_EPC  == false && response.waypoint_response != "ACCEPTED"){
                                            $("#note_modal").addClass("modal_wrap");
                                            $("#note_modal").removeClass("modal_hide");
                                            
                                        }
                                        else if(response.in_EPC  == false && response.waypoint_response == "ACCEPTED"){
                                            if(response.source == 'silver'){
                                                window.location.href = "/thank_you.html?epc=" + response.EPC_qualify+'&'+querystring;;
                                            }
                                            else if(response.source == 'silver_not_qualify'){
                                                $(".site_loader").hide()
                                                $("#not_qualify_modal2").addClass("modal_wrap");
                                                $("#not_qualify_modal2").removeClass("modal_hide");
                                                // fbq('track', 'LeadNotQualify');   
                                                fbq_custom("LeadNotQualify", window.location.href, formdata);                             
                                            }
                                            else
                                            {
                                                $(".site_loader").hide()
                                                $("#not_qualify_modal").addClass("modal_wrap");
                                                $("#not_qualify_modal").removeClass("modal_hide");
                                                // fbq('track', 'LeadNotQualify');
                                                fbq_custom("LeadNotQualify", window.location.href, formdata);
                                                
                                            }
                                        }
                                        else if(response.source == 'silver_not_qualify'){
                                            $(".site_loader").hide()
                                            $("#not_qualify_modal2").addClass("modal_wrap");
                                            $("#not_qualify_modal2").removeClass("modal_hide");
                                            // fbq('track', 'LeadNotQualify');  
                                            fbq_custom("LeadNotQualify", window.location.href, formdata);                              
                                        }
                                        else if(response.EPC_qualify == 'NO'){
                                            $(".site_loader").hide()
                                            $("#not_qualify_modal").addClass("modal_wrap");
                                            $("#not_qualify_modal").removeClass("modal_hide");
                                            // fbq('track', 'LeadNotQualify');
                                            fbq_custom("LeadNotQualify", window.location.href, formdata);
                                        }else{
                                            console.log(response.source);
                                            if(response.source == 'silver'){
                                                window.location.href = "/thank_you.html?epc=" + response.EPC_qualify+'&'+querystring;;
                                            }
                                            else
                                            {
                                                window.location.href = "/thankyou.html?epc=" + response.EPC_qualify+'&'+querystring;;
                                            }
                                            
                                        }

                                    } else {
                                        // not supplied postcode or house number 
                                        // not in our critera group
                                        console.log(response.error)
                                        if (response.error != "") {
                                            $(".custom-error").html("Unfortunately your postcode isn't eligible for this campaign.")
                                        }
                                        $(".custom-error").html(response.EPC_fail_reason)
                                        $(".hidden-error").addClass("display-errors")

                                    }
                                });

                                $(".temp-active").removeClass("temp-active")
                                $(".form-progress").css("width", ((new_group + 1) * _this.progress_percent) + "%")

                            } else {
                                setTimeout(function () {
                                    $(".temp-active").removeClass("temp-active")
                                    $(".form-progress").css("width", ((new_group + 1) * _this.progress_percent) + "%")
                                }, 300)
                            }

                        } else {
                            $(".hidden-error").addClass("display-errors")
                        }

                    }



                });
                console.log("hello");
            },
            test_form_action: function test_form_action() {
                let _this = this;

                $(".search_btn").on("click", function (e) {
                    e.preventDefault();
                    console.log("search EPC");

                    let payload = {
                        method: 'search_postcode',
                        data: $("#postcode")
                    }
                    my_app.db_req.send(payload, true).then((response) => {
                        // console.log('my response: ' + JSON.stringify(response, null, 2));
                        if (response.success) {
                            let addresses = response.address_data
                            let options_string = "";
                            addresses.array.forEach(element => {
                                let opt = "<option value='" + element.lmk - key + "'>" + element.address + "</option>";
                                options_string += opt;
                            });
                            $("#address_list").html(options_string);



                        } else {
                            // not supplied postcode or house number 
                            // not in our critera group
                            window.location.href = "/thankyou.html";

                            response.error
                        }
                    });



                });

                $(".field-group .cta").on("click", function (e) {
                    console.log("SUBMIT");
                    e.preventDefault();
                    $('.form-title').text('continue to see if you qualify');
                    let obj = JSON.parse($(this).attr("data-btn"))
                    let current_field_group = $(this).parents(".field-group")
                    let new_group = 15;
                    $(".field-group[data-group=" + new_group + "]").addClass("temp-active")
                    current_field_group.removeClass("active-group")
                    $(".temp-active").addClass("active-group");
                    if(new_group == 3){
                        $('.form-title').html('<span>Almost there</span> <span class="just_few">Just a few more details</span> ');
                    }

                    if (new_group == 15) {
                        let payload = {
                            method: 'EPC_SEARCH',
                            data: _this.test_form_info
                        }
                        my_app.db_req.send(payload, true).then((response) => {
                            console.log('my response: ' + JSON.stringify(response, null, 2));
                            if (response.success) {
                                console.log("success Custome");
                                // _this.test_form_info.epc_verified = response.epc_response
                                // _this.test_form_info.exact_match = response.exact_match
                                // my_app.form.post_waypoint();
                              
                                    window.location.href = "/thankyou.html";
                                
                            } else {
                                // not supplied postcode or house number 
                                // not in our critera group
                                console.log(response.error)
                            }
                        });
                        // my_app.form.post_waypoint(_this.test_form_info);

                        $(".temp-active").removeClass("temp-active")
                        $(".form-progress").css("width", ((new_group + 1) * _this.progress_percent) + "%")

                    } else {
                        setTimeout(function () {
                            $(".temp-active").removeClass("temp-active")
                            $(".form-progress").css("width", ((new_group + 1) * _this.progress_percent) + "%")
                        }, 300)
                    }

                });
            }
        },
        db_req: {
            send: async function send(payload, debug = false) {
                // return await fetch("/api/endpoint.php", {  // PRODUCTION ENDPOINT
                return await fetch("/api-search.php", { // DEV ENDPOINT
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                })
                    .then(data => debug ? data.text() : data.json())
                    .then(data => {
                        if (debug) console.log('DEBUG response: ' + payload.method + ' : ' + JSON.stringify(data, null, 2).replace(/\\"/g, '').replace(/<br\s*[\/]?>/gi, ' \n '));
                        return data
                    })
                    .catch((error) => console.log(error));
            }
        },
        countdown: {
            countDownDate: null,
            check_expired: null,
            now: null,
            timestamp: 1648771199,
             //timestamp: 1584554400,


            countdown_interval: null,
            init: function init() {
                const _this = this;
                _this.countDownDate = moment.unix(parseFloat(_this.timestamp))
                _this.now = new Date().getTime();
                _this.check_expired = _this.countDownDate - _this.now;

                if (_this.countdown_interval != null) {
                    if (check_expired < 0) {
                        _this.expire_lobby()
                        clearInterval(_this.countdown_interval);
                    } else if (_this.game_started) {
                        clearInterval(_this.countdown_interval);
                    }

                } else if (_this.countdown_interval == null) {
                    // let countDownDate = moment.unix(parseFloat(_this.timestamp)).add(30, 'seconds')   
                    _this.countdown_interval = setInterval(function () {
                        _this.now = new Date().getTime();
                        let distance = _this.countDownDate - _this.now;

                        // var d = new Date(_this.countDownDate);
                        // console.log(d.getFullYear());
                        // console.log(d.getMonth()+1);
                        // var d2 = new Date(_this.now);
                        // console.log(d2.getFullYear());
                        // console.log(d2.getMonth()+1);

                       // let years = String(Math.floor((distance % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24)))

                        let days = String(Math.floor((distance % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24)))
                        days = parseInt(days)+365;

                        let hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))

                        let mins = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)))




                        let secs = String(Math.floor((distance % (1000 * 60)) / 1000));
                        //(     distance %   (1000 * 60 * 60)  )   /   (1000 * 60)   

                        //Math.floor(  (     distance %   (1000 * 60 * 60)  )   /   (1000 * 60)    )


                        _this.countdown_hours = hours.length > 1 ? mins : "0" + mins
                        _this.countdown_mins = mins.length > 1 ? mins : "0" + mins
                        _this.countdown_secs = (secs.length > 1 ? secs : "0" + secs)

                        $(".days").html(days);
                        $(".hours").html(hours);
                        $(".minutes").html(_this.countdown_mins);
                        $(".seconds").html(_this.countdown_secs);

                        // console.log("MINS: "+ _this.countdown_mins)

                        if (distance < 0) {
                            clearInterval(_this.countdown_interval);
                            _this.countdown_mins = "EXPIRED";
                            _this.countdown_secs = ""
                        }
                    }, 1000);
                }
            }

        },
        phoneValidation: {
            inside: false,
            is_telephone_varified: 0,
            old_length: 0,
            new_length: 0,
            
            init: function init() {
                var that = this;
                debugger;
                $(document).on('keyup', '#telephone', function(event) {
                    var ewitch = event.which;
                    if (ewitch == 96) {
                        ewitch = 48;
                    } else if (ewitch == 97) {
                        ewitch = 49;
                    } else if (ewitch == 98) {
                        ewitch = 50;
                    } else if (ewitch == 99) {
                        ewitch = 51;
                    } else if (ewitch == 100) {
                        ewitch = 52;
                    } else if (ewitch == 101) {
                        ewitch = 53;
                    } else if (ewitch == 102) {
                        ewitch = 54;
                    } else if (ewitch == 103) {
                        ewitch = 55;
                    } else if (ewitch == 104) {
                        ewitch = 56;
                    } else if (ewitch == 105) {
                        ewitch = 57;
                    }
                    var keypressed = String.fromCharCode(ewitch);
                    var myarray = ['+', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                    if (jQuery.inArray(keypressed, myarray) == -1 || ewitch == 8) {
                        console.log("is NOT in array");
                        var _this = $(this);
                        setTimeout(function() {
                            that.new_length = that.getlength($('#telephone').val());
                            if (that.new_length != that.old_length) {
                                that.old_length = that.getlength($('#telephone').val());
                                that.validatephone(_this);
                            }
                        }, 10);
                        return;
                    } else {
                        console.log("is in array");
                        var _this = $(this);
                        setTimeout(function() {
                            that.old_length = that.getlength($('#telephone').val());
                            that.validatephone(_this);
                        }, 50);
                    }
                });
        
                $(document).on('paste', '#telephone', function() {
                    debugger;
                    var _this = $(this);
                    setTimeout(function() {
                        that.validatephone(_this);
                    }, 50);
                });
        
                $(document).on('change', '#telephone', function() {
                    var _this = $(this);
                    setTimeout(function() {
                        if (that.is_telephone_varified == 0 && that.inside == false) {
                            setTimeout(function() {
                                that.validatephone(_this);
                            }, 100);
                        }
                    }, 1000);
                });
            },
            getlength: function getlength(number) {
                return number.toString().length;
            },
            isnotInteger: function isnotInteger(data) {
                if ($.isNumeric(data)) {
                    return false;
                } else {
                    return true;
                }
            },
            validatephone: function validatephone(_this) {
                var number = _this.val();
                var number_length = this.getlength(number);
                if ((number_length < 10 || number_length > 13) || (number_length == 10 && number.substring(0, 1) == '0')) {
                    debugger
                    this.is_telephone_varified = 0;
                    $("#tel-check").val(0);
                    $("#telephone").removeClass("is-valid");
                    $("#telephone").addClass("is-invalid");

                } else if (this.isnotInteger(number)) {
                    debugger
                    this.is_telephone_varified = 0;
                    $("#tel-check").val(0);
                    $("#telephone").removeClass("is-valid");
                    $("#telephone").addClass("is-invalid");
                } else {
                    var uk_mob_number = number;
                    if (number_length < 11 && uk_mob_number.substring(0, 1) != '0') {
                        uk_mob_number = '0' + uk_mob_number;
                    } else if (number_length > 11 && uk_mob_number.substring(0, 2) == '44') {
                        uk_mob_number = uk_mob_number.replace(/^44/, '0');
                    } else if (number_length > 12 && uk_mob_number.substring(0, 3) == '+44') {
                        uk_mob_number = uk_mob_number.replace('+44', '0');
                    } else if (number_length > 12 && uk_mob_number.substring(0, 4) == '0044') {
                        uk_mob_number = uk_mob_number.replace(/^0044/, '0');
                    }
                    number = uk_mob_number;
                    if (this.getlength(number) == 11) {
                        this.inside = true;
                        $.ajax({
                            url: window.location.origin + "/mobile-validation.php",
                            data: {
                                number: number
                            },
                            type: "post",
                            success: function(data) {
                                if (data == 1) {
                                    console.log("success mobile");
                                    this.is_telephone_varified = 1;
                                    $("#phone-err").text("");
                                    $("#tel-check").val(1);
                                    $("#telephone").addClass("is-valid");
                                    $("#telephone").removeClass("is-invalid");
                                   
                                } else {
                                    this.is_telephone_varified = 0;
                                    $("#tel-check").val(0);
                                    $("#telephone").addClass("is-invalid");
                                    $("#telephone").removeClass("is-valid");
                                }
                            }
                        });
                    } else {
                        debugger
                        this.is_telephone_varified = 0;
                        $("#tel-check").val(0);
                        $("#telephone").removeClass("is-valid");
                        $("#telephone").addClass("is-invalid");
                    }
                }
            }
        }

    }

})();
$(document).on('click', '#AddressCapture_FindButton', function(){
    $('#AddressCapture_FindButton').addClass('active_now');
});

function fbq_custom(trace = 'PageView', source_url = '', data = {}){
    debugger;
    data.trace = trace;
    data.source_url = source_url
    $.ajax({
        url: "https://fundmy-heating.co.uk/conversion-api.php",
        data: data, 
        type: "post",  
        success: function (data) {
            console.log(data);
            console.log("server event test");
        }
     });
}


function serialize(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
}

// $('#postcode').keyup(function(){
//     if($(this).val() == ''){
//         $('#AddressCapture_FindButton').removeClass('active_now');
//     }
// })
export {
    basic_js
};